import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/tasks`, {params: {...filter}})
  },

  create(task){
    return Http.post(`/tasks`, {task: {
      ...task,
    }})
  },

  update(task){
    return Http.put(`/tasks/${task.id}`, {
      task: {
        ...task,
      },
    });
  },

  show(id) {
    return Http.get(`/tasks/${id}`);
  },

  delete(id){
    return Http.delete(`/tasks/${id}`)
  }

}
